export default __webpack_public_path__ + "static/logo23-97b210b519a3b5149cf66fc43f62458b.png";